import { render, staticRenderFns } from "./activities-section.vue?vue&type=template&id=61ff2b8d"
import script from "./activities-section.vue?vue&type=script&lang=js"
export * from "./activities-section.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports